import {BaseEntity} from "yt-ng-framework";

export class OrgJed extends BaseEntity{
    constructor(){
        super();
    }

Naziv: string=null;
TataID: number=null;
Items: OrgJed[]=null;

Deserialize(input: any){   
    this.ID = input.ID;
    this.Naziv = input.Naziv;
    this.TataID = input.TataID;
    if (input.Items!=null){
        this.Items=[];
        input.Items.forEach(Item => {
            return this.Items.push(new OrgJed().Deserialize(Item))
        });
    }

    return this;
}

    Serialize(input:OrgJed){
        input.Items = null;
        return input;
    }
    

}